import t_12_2505 from './KZ.Т.12.2505.svg'
import t_12_2505_b from './KZ.Т.12.2505 black.svg'

export default [
  t_12_2505,
  t_12_2505_b,
]
